import React, { FC } from 'react';

import SubscribeContainer from 'buyside/components/presentation/Subscribe/SubscribeContainer';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';

const SubscribePageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="the available payment options">
      <SubscribeContainer />
    </ErrorBoundary>
  );
};

export default SubscribePageRoot;
